import Vue from 'vue';
import App from './App';
import { router } from './router';
import store from '@/store/store';

//全局脚本1
require("./global")

//全局脚本2
import common from './utils/function'
Vue.use(common)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import Meta from 'vue-meta'
Vue.use(Meta)

//引入Md5
import md5 from 'js-md5'
Vue.prototype.$md5 = md5

import axios from './api/axios'
axios.install(Vue);

// import Vconsole from 'vconsole';
// new Vconsole();

//多语言标识
const i18n = new VueI18n({
  locale: 'zh-cn', 
  messages: {
    'zh-cn': require('./assets/lang/zh'),
    'en-GB': require('./assets/lang/en')
  }
})
new Vue({
  router,
  el: '#app',
  i18n,
  store,
  render: h => h(App)
});
